
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/FAQforwholesalebuyers",
      function () {
        return require("private-next-pages/FAQforwholesalebuyers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/FAQforwholesalebuyers"])
      });
    }
  